<template lang='pug'>
.error-contaienr
    .msg {{msgList[type]}}
</template>

<script>
export default {
    data() {
        return {
            msgList: ['该页面暂时无法访问'],
            type: this.$route.query.type || 0
        }
    },
    created() {
    }
}
</script>

<style scoped lang='less'>
.error-contaienr {
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2em;
}
</style>